export default {
  nfcUID: 'NFC UID',
  productCode: '产品代码',
  productName: '产品名称',
  size: '尺码',
  upc: 'UPC',
  requiredChannel: '预期的渠道',
  tagTypeDesc: '实际标签类型描述',
  plant: '仓库',
  status: '状态',
  tagStatus: '绑定状态',
  workstation: '工作台',
  orderNumber: '订单号',
  taggingDate: '绑定日期',
  sendDate: '发送日期',
  sendStatus: '发送状态',
  action: '操作',
  operation: '操作',
  operator: '操作人',
  apiDate: 'API日期',
  dateLimt: '超过查询日期长度限制',
  system: '系统',
  nfcUidReport: 'NFC UID报表',
  operationDate: '操作日期',
  unbind: '解绑',
  unbindMessage: '您确定要解绑吗？',
  unbindError1: '已禁用的nfc标签无法解绑',
  unbindError2: '解绑nfc转移ant接口失败',
  disableError: '禁用转移ant接口失败'
}
